document.addEventListener('DOMContentLoaded', function () {
  let isProcessing = false;
  let sidebarCache = null;
  let currentSidebar = null;
  
  async function fetchSizeGuideSnippet() {
    try {
      const productHandle = window.location.pathname.split('/').pop().split('?')[0];
      
      const response = await fetch(`/products/${productHandle}?section_id=size-drawer`, {
        method: 'GET',
        headers: {
          'Accept': 'text/html',
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.text();
    } catch (error) {
      return null;
    }
  }
  
  function openSidebar(sidebar, triggeredBy) {
    if (triggeredBy) {
      sidebar.activeElement = triggeredBy;
    }
    
    sidebar.classList.add("size-guide-sid-active");
    document.documentElement.classList.add("prevent-scroll");
    
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        sidebar.style.setProperty("--m-bg-opacity", "0.5");
        sidebar.style.setProperty("--translate-x", "0");
      });
    });
  }
  
  function closeSidebar() {
    if (!currentSidebar) return;
    
    cleanupEventListeners();
    
    currentSidebar.style.setProperty("--m-bg-opacity", "0");
    currentSidebar.style.setProperty("--translate-x", "100%");
    
    setTimeout(() => {
      currentSidebar.classList.remove("size-guide-sid-active");
      document.documentElement.classList.remove("prevent-scroll");
      
      setTimeout(() => {
        currentSidebar?.remove();
        currentSidebar = null;
      }, 100);
    }, 300);
  }
  
  function handleOutsideClick(event) {
    if (!currentSidebar) return;
    
    const sidebarContent = currentSidebar.querySelector('.size-guide-sidebar-content, .size-guide-content, .m-cart-drawer__inner');
    const isOpenButton = event.target.closest('#open-cart-from-size-guide');
    
    if (sidebarContent && !sidebarContent.contains(event.target) && !isOpenButton) {
      event.preventDefault();
      event.stopPropagation();
      closeSidebar();
    }
  }
  
  async function openSizeGuideSidebar(triggeredBy) {
    if (currentSidebar) {
      closeSidebar();
      return;
    }
    
    let content;
    if (sidebarCache) {
      content = sidebarCache;
    } else {
      content = await fetchSizeGuideSnippet();
      if (!content) {
        return;
      }
      sidebarCache = content;
    }
    
    const sidebarContainer = document.createElement('div');
    sidebarContainer.className = 'size-guide-sidebar-container';
    sidebarContainer.style.cssText = `
      --m-bg-opacity: 0;
      --translate-x: 100%;
    `;
    
    sidebarContainer.innerHTML = content;
    document.body.appendChild(sidebarContainer);
    currentSidebar = sidebarContainer;
    
    setupSidebarEventListeners(sidebarContainer);
    openSidebar(sidebarContainer, triggeredBy);
  }
  
  function setupSidebarEventListeners(sidebar) {
    const closeButton = sidebar.querySelector('.size-guide-close, .m-cart-drawer__close, .m-size-drawer__close');
    const continueShoppingButton = sidebar.querySelector('.m-cart-drawer-continue');

    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeSidebar();
      });
    }


    if (continueShoppingButton) {
    continueShoppingButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeSidebar();  // Aquí cierras el cart drawer
    });
  }
  
    
    const escapeHandler = (e) => {
      if (e.key === 'Escape') {
        closeSidebar();
        document.removeEventListener('keydown', escapeHandler);
      }
    };
    document.addEventListener('keydown', escapeHandler);
    
    setTimeout(() => {
      document.addEventListener('click', handleOutsideClick, true);
    }, 100);
    
    const scripts = sidebar.querySelectorAll('script');
    scripts.forEach(script => {
      const newScript = document.createElement('script');
      if (script.src) {
        newScript.src = script.src;
      } else {
        newScript.textContent = script.textContent;
      }
      document.head.appendChild(newScript);
    });
  }
  
  function cleanupEventListeners() {
    document.removeEventListener('click', handleOutsideClick, true);
  }
  
  function handleSizeGuideClick(event) {
    if (isProcessing) return;
    
    const sizeGuideBtn = event.target.closest('#open-cart-from-size-guide');
    if (!sizeGuideBtn) return;
    
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    isProcessing = true;
    openSizeGuideSidebar(sizeGuideBtn);
    
    setTimeout(() => {
      isProcessing = false;
    }, 500);
  }
  
  document.addEventListener('click', handleSizeGuideClick, true);
  
  function cleanupEventListeners() {
    document.removeEventListener('click', handleOutsideClick);
  }
  
  window.openSizeGuide = function() {
    openSizeGuideSidebar();
  };
  
  window.closeSizeGuide = function() {
    closeSidebar();
  };
  
  window.preloadSizeGuide = function() {
    fetchSizeGuideSnippet();
  };
});
